
<div class="search-back">
	<lottie-anim class="animated fadeIn" #loadingAnim [options]="{animation: 'gears', autoplay: true, loop: true }"
				 [height]="300"></lottie-anim>
</div>>
<div class="search-dialog-content">

	<div class="search-dialog-top">

        <div class="d-flex align-items-center" style="gap:5px">
            <form class="chat-form-container" style="flex-grow: 1; padding: 0.5rem;" (submit)="sendMessage(); $event.preventDefault()">
                <div class="chat-form">
                <textarea #chatInput [ngModel]="prompt()" (ngModelChange)="prompt.set($event); adjustTextareaHeight()"
                          name="chatInput" [placeholder]="'tabot.free_search' | translate" autocomplete="off" rows="1"
                          (keydown)="onTextareaKeydown($event)" (keyup)="onTextareaKeyup($event)">
				</textarea>

                    @if (!loading()) {
                        <button class="action-button" type="submit" style="transform: rotate(180deg)"
                                [disabled]="loading()">
                            <mat-icon class="chat-arrow" svgIcon="chat-arrow" aria-hidden="true"></mat-icon>
                        </button>
                    }
                    @if (loading()) {
                        <button type="button" class="action-button loading" (click)="cancelOngoingRequest()">
                            <mat-icon svgIcon="chat-square" aria-hidden="true"></mat-icon>
                        </button>
                    }
                </div>
            </form>
            <button mat-icon-button color="accent" (click)="cancel()" style="padding: 6px;">
                &#10005;
            </button>
        </div>

		@if (searchMode() === 'advanced') {
			<div class="mt-3 d-flex align-items-center justify-content-center" style="gap:5px">
				<button type="button" class="btn btn-block d-flex align-items-center btn-light flex-grow-1 text-accent" style="gap:10px" (click)="clearAdvancedSearch()">
					<mat-icon svgIcon="reload" aria-hidden="true"></mat-icon>
					<div class="text-ellipsis" >{{ lastSearchTerm() }}</div>
				</button>
			</div>
		}

		@if (searchMode() !== 'advanced' && !selectedOffers()[0]) {
			<div class="popover-panel-container">
				<div class="popover-panel animated fadeInUp">
					<h4 class="text-center mt-2 mb-3">{{ 'תשאלו אותי' | translate }}</h4>
					@for (question of chatService.questions; track question.id) {
						<div class="popover-question" [class.active]="activeQuestion === question">
							<div class="popover-question-title" (click)="selectQuestion(question)">
								<mat-icon>keyboard_arrow_down</mat-icon>
								<span>{{ question.text }}</span>
							</div>
							@if (activeQuestion === question) {
								<div class="animated fadeInUp faster pt-2">
									<app-chat-search-question [question]="question"
															  (apply)="onQuestionApply($event)"></app-chat-search-question>
								</div>
							}
						</div>
					}
				</div>
			</div>
		}

	</div>


	@switch (searchMode()) {
		@case ('advanced') {
			<div class="offers-menu-cat-ai" >
				<menu-offers-container>
					@for (member of aiMessages(); track member._id) {
						@switch (member.type) {
							@case ('diner') {
								<div class="diner-header">
									<div>{{member.data.dinerName}}</div>
								</div>
							}
							@case ('offer') {
								<div class="menu-offer"
									 [id]="'cat_' + member._id"
									 (mousedown)="aiOfferClick(member,$event)"
									 [ngClass]="{'_active':$storage.order.offerCounters[member.viewItem.offer], '_disabled': member.viewItem.stockDisabled, 'animated fadeInUp fast': member._new}">
									<div class="menu-offer-body">
										<div class="_body">
											<div class="menu-offer-title">{{ member.data.itemNameDisplay || member.viewItem.name }}</div>
											@if (member.description_display != 'hide') {
												<div class="menu-offer-description">{{ member.data.itemDescriptionDispaly || member.viewItem.description }}
												</div>
											}
											<div class="menu-offer-price">
												@if (member.viewItem.price > 0) {
													<div class="_price text-xs pb-1 font-weight-bold" >{{ member.viewItem.price | lcurrency }}</div>
												} @else {
													<div class="_price"></div>
												}
												<app-offer-attributes [offer]="member.viewItem"></app-offer-attributes>
											</div>
										</div>
										<!--[class.no-image]="offer.iconImage" [appBgImage]="offer.imageURL" [model]="cat"-->
										<div class="_image" [ngStyle]="member.viewItem.catStyle || member.viewItem.cardStyle"
											 [class.stock-disabled]="member.viewItem.stockDisabled">
											<img [appImageSrc]="member.viewItem.imageURL" [model]="member" loading="lazy"/>
											<app-offer-marketing [offer]="member.viewItem" [$storage]="$storage"></app-offer-marketing>
										</div>
									</div>
								</div>
							}
							@case ('intro') {
								<div class="alert alert-info _intro">
									{{member.data.intro}}
								</div>
							}
							@case ('info') {
								<div class="alert alert-info _intro">
									{{member.data.info}}
								</div>
							}
							@case ('recommendationReason') {
								<div class="alert alert-info _recommendation">
									{{member.data.recommendationReason}}
								</div>
							}
						}
					}
				</menu-offers-container>
			</div>

			@if(processingMessage()) {
				<div class="p-3" >
					<div class="chat-spinner-message dark">
						<div class="dot"></div>
						<div class="dot"></div>
						<div class="dot"></div>
					</div>
				</div>
			}


		}
		@default {

			<div class="offers-menu-cat" [@listAnimation]="selectedOffers().length">
				<menu-offers-container>
					@for (offer of selectedOffers(); track offer._id) {
						<div class="menu-offer"
							 [id]="'cat_' + offer._id"
							 (mousedown)="menuItemClick(offer,$event)"
							 [ngClass]="{'_active':$storage.order.offerCounters[offer.offer], '_folder':offer.type == 'folder', '_disabled': offer.stockDisabled}">
							<div class="menu-offer-body">
								<div class="_body">
									<div class="menu-offer-title">{{ offer.name }}</div>
									<div class="menu-offer-description"
										 *ngIf="offer.description_display != 'hide'">{{ offer.description }}
									</div>
									<div class="menu-offer-price">
										@if (offer.price > 0) {
											<div class="_price">{{ offer.price | lcurrency }}</div>
										} @else {
											<div class="_price"></div>
										}
										<app-offer-attributes [offer]="offer"></app-offer-attributes>
									</div>
								</div>
								<!--[class.no-image]="offer.iconImage" [appBgImage]="offer.imageURL" [model]="cat"-->
								<div class="_image" [ngStyle]="offer.catStyle || offer.cardStyle"
									 [class.stock-disabled]="offer.stockDisabled">
									<img [appImageSrc]="offer.imageURL" [model]="offer" loading="lazy"/>
									<app-offer-marketing [offer]="offer" [$storage]="$storage"></app-offer-marketing>
								</div>
							</div>
						</div>
					}
				</menu-offers-container>
			</div>

		}
	}

	@if (hasOffers()) {
		<div class="search-dialog-bottom animated fadeIn">
			<button mat-raised-button color="accent" class="lg main-continue-btn" type="button" (mousedown)="addItemsToBasket()">
				<div class="_inner">
					<span>{{"TD.add-items" | translate}}</span>
					<b><!--{{(grandTotal) | lcurrency}}--></b>
					<div class="_cont rotate-rtl"><mat-icon svgIcon="arrow_next"></mat-icon></div>
				</div>
			</button>
		</div>
	}

</div>



